import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import { memo } from "react";
// import makeStyles from "@mui/styles/makeStyles";

function ButtonControl(props) {
  const { variant, text, size, color, margin, onClick, isSaving, ...other } =
    props;
  return (
    <Button
      variant={variant || "contained"}
      color={color || "primary"}
      size={size || "large"}
      margin={margin || "normal"}
      onClick={onClick}
      disabled={isSaving}
      {...other}
    >
      {isSaving && (
        <CircularProgress
          size={20}
          color="inherit"
          sx={{ mr: 1 }}
          disableShrink
        />
      )}
      {text}
    </Button>
  );
}

export default memo(ButtonControl);
